module.exports = __webpack_public_path__ + "static/img/4.3861052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/4.png
// module id = q8Ik
// module chunks = 0